import * as React           from 'react'
import { FormattedMessage } from 'react-intl'
import { Link }             from 'react-router-dom'

import Button                              from '@material-ui/core/Button'
import CardActions                         from '@material-ui/core/CardActions/CardActions'
import CardContent                         from '@material-ui/core/CardContent/CardContent'
import CardHeader                          from '@material-ui/core/CardHeader/CardHeader'
import Typography                          from '@material-ui/core/Typography'
import { InjectedFormikProps, withFormik } from 'formik'

import { Communication }                           from '../../redux/ducks'
import hooks                                       from '../../testing-hooks'
import { InlineError, LoadingOverlay }             from '../atoms'
import CredentialsChunk                            from './chunks/CredentialsChunk'
import { genValueMapper, proxyFormikSubmission }   from './form-utils'
import { credentialsSchema, emptyCredentials }     from './schemas'
import { CredentialsFields, FormikComponentProps } from './types'
import {indraEnabled, muiPaletteOverride} from '../../theme'

type Props = InjectedFormikProps<Communication, CredentialsFields>

const LoginForm = (props: Props) => {
  const phrasing = {
    loginPrompt:
      (
        <Typography variant={'subheading'}>
          <FormattedMessage
            id={'login.prompt'}
            defaultMessage={'Please log in with your credentials'}
          />
        </Typography>
      ),
    login:
      (
        <FormattedMessage
          id={indraEnabled ? 'login.indra' : 'login.login'}
          defaultMessage={'Login'}
        />
      ),
    forgotPassword:
      (
        <FormattedMessage
          id={'login.forgot-password'}
          defaultMessage={'Forgot Password'}
        />
      ),
    featureNotReady:
      (
        <FormattedMessage
          id={'tooltip.featureNotReady'}
          defaultMessage={'This feature is not ready yet'}
        />
      ),
  }

  const { handleSubmit, fetching, error } = props

  const errorMessage = error
    ? <InlineError i18nErrorId={error} />
    : null

  const form = (
    <form onSubmit={handleSubmit}>
      <CardHeader title={phrasing.login} subheader={phrasing.loginPrompt} />

      <CardContent>
        <CredentialsChunk {...props} />
      </CardContent>

      {errorMessage && (
        <CardContent>
          {errorMessage}
        </CardContent>
      )}

      <CardActions>
        <Button
          data-test-id={hooks.buttons.login}
          type={'submit'}
          variant={'raised'}
          color={indraEnabled ? 'secondary' : 'primary'}
        >
          {phrasing.login}
        </Button>
        <Link to={'/forgot-password'}>
          <div style={{color: muiPaletteOverride.text.primary, fontFamily: "Roboto"}}>
            {phrasing.forgotPassword}
          </div>
        </Link>
      </CardActions>
    </form>
  )

  return (
    <LoadingOverlay show={fetching}>
      {form}
    </LoadingOverlay>
  )
}

export default withFormik<
  FormikComponentProps<CredentialsFields>
  & Communication, CredentialsFields
>({
  mapPropsToValues: genValueMapper(emptyCredentials),
  validationSchema: credentialsSchema,
  handleSubmit:     proxyFormikSubmission,
})(LoginForm)



// WEBPACK FOOTER //
// ./src/components/forms/LoginForm.tsx